import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnDE: CultureInfo = {
  name: 'en-DE',
  displayName: 'English (Germany)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-DE',
  parent: CultureInfoEn
};
